import { render, staticRenderFns } from "./text2.vue?vue&type=template&id=68c4162e"
import script from "./text2.vue?vue&type=script&lang=js"
export * from "./text2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports